import axios from "axios";
import api from "./api";
import { CollaboratorType, ListCollaborator, CollaboratorInsert } from "../types/Collaborator";

export async function findAllCollaborators(
  currentPage: number,
  perPage: number,
  searchNome?: string,
  searchCpf?: string,
  searchEmail?: string,
  searchInstitution?: number | null,
  searchStatus?: number,
): Promise<ListCollaborator> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/collaborator/all`;

  try {

    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      params: {
        page: currentPage,
        perPage,
        searchNome,
        searchCpf,
        searchEmail,
        searchInstitution,
        searchStatus,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data;

    return result;

  } catch (error) {
    console.error("Erro ao buscar colaboradores:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao buscar colaboradores"
    );
  }
}

export async function findCollaborator(
  collaboratorId: string,
): Promise<CollaboratorType> {

  const apiUrl = `${process.env.REACT_APP_API_URL}/collaborator/${collaboratorId}`;

  try {

    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    const response = await api.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const result = response.data;

    return result;

  } catch (error) {
    console.error("Erro ao consultar o colaborador:", error);
    throw new Error(
      error instanceof Error
        ? error.message
        : "Erro desconhecido ao consultar o colaborador"
    );
  }
}

export async function createCollaborator(
  data: CollaboratorInsert
): Promise<void> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/collaborator`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    await axios.post(
      apiUrl,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      },
    );
    
  } catch (error) {
    throw new Error(`Erro ao cadastrar o colaborador: ${error}`);
  }
}

export async function updateCollaborator(
  collaboratorId: string,
  data: Partial<CollaboratorInsert>
): Promise<void> {
  const apiUrl = `${process.env.REACT_APP_API_URL}/collaborator/${collaboratorId}`;
  try {
    const token = sessionStorage.getItem("authToken");

    if (!token) {
      throw new Error("Token não encontrado");
    }

    await axios.put(
      apiUrl,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      },
    );
    
  } catch (error) {
    throw new Error(`Erro ao atualizar o colaborador: ${error}`);
  }
}
